import { Popover, PopoverContent, PopoverTrigger } from "Components/ui/popover";
import { Lock } from "lucide-react";
import { useEffect, useState } from "react";

function DropCard({
  title,
  data,
  selected,
  setSelected,
  withImages,
  withLabel,
  onlyOne,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!selected) setSelected(data[0]);
  }, [selected]);

  return (
    <Popover
      open={open}
      onOpenChange={() => {
        setOpen(!open);
      }}
    >
      <PopoverTrigger>{title}</PopoverTrigger>

      <PopoverContent className="border-none bg-border-darkNew  border-border-darkNew rounded-lg p-2 w-auto ">
        <div className="flex flex-col gap-2">
          {data.map((item, index) => {
            if (item?.value == "disabled") {
              return (
                <div
                  key={index}
                  className={`opacity-[0.3] cursor-not-allowed  p-2 pr-3 rounded-lg flex items-center justify-between w-full gap-4`}
                >
                  {item?.label} <Lock size={15} />
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className={`${
                    selected?.value === item?.value &&
                    "opacity-[0.7] border-2 border-border-darkNew  hover:opacity-100"
                  } opacity-[0.7] hover:opacity-100 cursor-pointer hover:bg-grey-DARK p-2 pr-10 rounded-lg`}
                  onClick={() => {
                    setSelected(item);
                    setOpen(false);
                  }}
                >
                  {item?.label}
                </div>
              );
            }
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default DropCard;
